import React from 'react'
import './HeaderComponent.style.less'
import { Typography, Button } from 'antd'
import { ArrowLeftOutlined } from '@ant-design/icons'
import { useNavigate } from 'react-router-dom'

const { Title } = Typography
type Props = {
  title: string
  isBack?: boolean
}

function HeaderComponent(props: Props) {
  const navigate = useNavigate()
  return (
    <div className="contain-header">
      {props.isBack && (
        <Button
          onClick={() => navigate(-1)}
          type="text"
          className="back-button"
        >
          <ArrowLeftOutlined className="plus-icon" />
        </Button>
      )}
      <Title level={2} style={{ margin: 0 }}>
        {props.title}
      </Title>
    </div>
  )
}

export default HeaderComponent
